module.exports = __webpack_public_path__ + "img/2012-08-18 09.21.53.19b8ea45.jpg";